module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-footer/usc-footer.component.html
// module id = ../../../../../src/app/components/usc-store/usc-footer/usc-footer.component.html
// module chunks = main